import { render, staticRenderFns } from "./DashboardHra.vue?vue&type=template&id=654d2e3e&scoped=true&lang=pug&"
import script from "./DashboardHra.vue?vue&type=script&lang=js&"
export * from "./DashboardHra.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "654d2e3e",
  null
  
)

export default component.exports